module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n2n6n9n-146f358dad922677027fac189bd08700.svg";